import React, { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'
import './index.css';

// ** Import JWT Service
import './utility/useJwt'
import axios from 'axios';

// 서비스 데이터 조회 함수
const fetchServiceData = async () => {
  try {
    const response = await axios.get('/user/service')
    if (response.success) {
      localStorage.setItem('serviceData', JSON.stringify(response.data))
    }
  } catch (error) {
    console.error('서비스 데이터 조회 실패:', error)
  }
}

// 배너 데이터 조회 함수
const fetchBannerData = async () => {
  try {
    const response = await axios.get('/user/service/banner');
    if (response.success) {
      localStorage.setItem('bannerData', JSON.stringify(response.data))
    }
  } catch (error) {
    console.error('배너 데이터 조회 실패:', error)
  }
}


// 사용자 정보 조회 함수
const fetchUserData = async () => {
  try {
    const token = localStorage.getItem('accessToken')
    if (token) {
      const response = await axios.get("/user/auth/info");
      if (response.success) {

        localStorage.setItem("userData", JSON.stringify(response.user));
      }
    }
  } catch (error) {
    console.error('사용자 정보 조회 실패:', error)
  }
}

// 페이지 로드 시 데이터 조회
const initializeData = async () => {
  await Promise.all([
    fetchServiceData(),
    fetchBannerData(),
    fetchUserData()
  ])
}

window.addEventListener('load', initializeData)

// ** Lazy load app
const LazyApp = lazy(() => import('./App'))

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Suspense fallback={<div>Loading...</div>}>
      <LazyApp />
    </Suspense>
  </BrowserRouter>
);

